import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import {
  WEB_COMPONENT_PHASR_MONITORED_RULES_GRID,
} from '../../../webcomponents.constants';
import { TemplateState } from '../../../types/common/types';
import { PhasrMonitoredRulesGridWebComponent } from '../../phasrMonitoredRulesGrid';

export class PhasrMonitoredRulesView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $phasrMonitoredRulesGrid: PhasrMonitoredRulesGridWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $phasrMonitoredRulesGrid: this.shadow.querySelector(WEB_COMPONENT_PHASR_MONITORED_RULES_GRID),
    };
  }

  public buildSuccessView() {
    if (!this.dom.$phasrMonitoredRulesGrid.started) {
      this.dom.$phasrMonitoredRulesGrid.injectDependencies(this.dependencies);
      this.dom.$phasrMonitoredRulesGrid.start().then().catch(console.error);
    }
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }
}